import { hexToHSL } from "~/lib/utils";

export function isLightColor(color: string) {
	const { lightness } = hexToHSL(color);

	return lightness > 70;
}
